module.exports = __webpack_public_path__ + "static/about10-28a79aff24ac20e9576eac1c89b7faf3.png";